import {
    faAlarmExclamation,
    faArrowAltFromLeft, faArrowAltFromRight,
    faCalendarAlt,
    faCheckSquare,
    faExclamation, faExclamationTriangle,
    faHistory,
    faShareSquare,
    faTimesCircle
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Avatar,
    Card,
    CardContent,
    Divider,
    Grid,
    List,
    Typography,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup
} from '@material-ui/core';
import { AssignmentTurnedIn, CompareArrows as CompareArrowsIcon } from '@material-ui/icons';
import clsx from 'clsx';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { DateFnsFormats, formatAs, formatDateRange, getAsLongDate, getAsLongDateTime, getTimeOnly, getAsTimeFormat, getAsStartAndEndTimeFormat, removeBrowserTimezoneConversion } from '../../../../common-client2/src/services/ukgDateTime';
import * as Aux from '../../../auxilaries';
import CollapsibleTable from '../../components/CollapsibleTable/CollapsibleTable';
import { EmployeeProposableShifts, HistoryPanel, ListSelect, ProposalCard, SearchMultiSelect, ValidationErrorPanel } from '../../components/core';

import CollapsableCard from '../../../../common/components/UI/CollapsableCard/CollapsableCard';
import { MultipleDayPicker } from "../../../../common/components/UI/Datepicker/MultipleDayPicker";
import {
    PostedRequestDisplay,
    RequestSource, RequestStatus,
    RequestSubtypes,
    RequestTypes, ShiftSegmentTypeName,
    VoluntaryTimeOffType as TimeOffType,
    TorCreationType,
    ValidationTypeName
} from '../../../Enums';
import { SliderPartialRequestWrapper } from '../../components/SliderPartialRequest';
import { SidePanelDetails } from '../SidePanel';
import AvailableTimeOffRequest from './AvailableTimeOffRequest';
import { handleRejectProposal } from './handlers';
import NumberedStepContainer from './NumberedStepContainer';
import { handleChangeProposalPartial } from './PartialShiftHelper';
import RequestSelectionStep from './RequestSelectionStep';
import TimeOffRequestCreationStep from './TimeOffRequestCreationStep';

const noop = () => { };

/**
 *
 * @param {int} offerId if of offer
 * @param {int} status status of offer
 * @param {Array} shifts Array of shift objects
 * @param {string} orgJob
 * @param {string} employeeName
 * @param {string} label
 * @param {int} source 0 if offeror, 1 if requester
 * @param {int} type ManagerSetting type, 0: To Cover, 1: To swap
 * @param {*} proposals
 */
export function buildUIShift(
    offerId,
    status,
    shifts,
    orgJob,
    employeeName,
    label,
    source,
    type,
    history,
    details,
    proposals = [],
    isValid = true,
    rawValidationDetails = [],
    statusValidationDetails = [],
) {
    return {
        type,
        source,
        status,
        label,
        offerId,
        shifts,
        employeeName,
        location: orgJob.location,
        job: orgJob.job,
        history: history,
        details,
        proposals: type === RequestTypes.shiftSwap ? proposals : undefined,
        isValid: isValid,
        rawValidationDetails: rawValidationDetails,
        statusValidationDetails: statusValidationDetails
    }
}


export const generateActionErrorMessage = (offer, managerSettings, error) => {
    let setting = managerSettings.find(setting => setting.id === offer.managerSettingId)
    error.exists = true;
    error.message = setting.name + ' offer already exists';
    return error;
}

/**
 * 
 * @param {number[]} settingAggregateRootIds 
 * @param {*[]} managerSettings 
 * @param {*} error 
 */
export const generateMultiSettingActionErrorMessage = (settingAggregateRootIds, managerSettings) => {
    const settingNames = managerSettings.filter(setting => settingAggregateRootIds.includes(setting.aggregateRootId)).map(x => x.name).join(',');
    return {
        exists: true,
        message: settingNames + ' offer already exists'
    };
}
/**
 *  @brief Function builds a Toast UI object, used for brevity
 *  @param {int} _id_ [in] ID to pass
 *  @param {int} _shift_ [in] the shift retrieved from .NET backend
 *  @param {string} _typeNum_ [in] Calendar ID, 0-> My Shift, 1-> Trades, 2-> My Requests
 *  @param {object} _statusDictionary_ [in] Dictionary of all possible statuses and attributes related to it
 *  @param {object} _rawData_ [in] Offer object
 *  @param {boolean} _isMonthly [in] Modify enddate if it is monthly
 *  @param {int} _source_ [in] 0 -> Offeror, 1 -> Requester
 *  @param {boolean} _isPrivate_ [in] Is private offer
 *  @param {boolean} _hasStatuses_ [in] Does raw data contain a status
 *
 *  @return Toast UI Schedule object.
 */
export function buildUISchedule(id, shift, typeNum, statusDictionary = {}, rawData, isMonthly, source, isPrivate = false, isAvailableOffer = false, isOwnProposals = false, hasStatuses = false, managerSettings = [], selectedManagerSettingId, postedRequestDisplay, isSkipValidation = false) {
    let label = (isPrivate) ? 'Privately ' : '', color = '';
    let isVisible = true;
    if (hasStatuses) {
        if (isOwnProposals) {//&& rawData.status !== 7
            let proposal = rawData.proposals[0]
            color = statusDictionary[proposal.status].color;
            label = statusDictionary[proposal.status].value;
        } else {
            color = statusDictionary[rawData.status].color;
            label = statusDictionary[rawData.status].value;
        }
    }
    const isShiftOrPaycode = typeNum === '0' || typeNum === '1';
    label += isShiftOrPaycode ? ((shift.label) ? shift.label + ' ' : '') + Aux.createTimeLabelFromShift(shift) : '';

    const managerSettingId = isAvailableOffer && selectedManagerSettingId ? selectedManagerSettingId : rawData.managerSettingId;
    const managerSetting = managerSettings.find(x => x.id === managerSettingId);
    if (isAvailableOffer) {
        if(rawData.isPartial && rawData.partialShift){
            label = Aux.getScheduleTitle(postedRequestDisplay, rawData.partialShift, managerSetting);
        }
        else{
            label = Aux.getScheduleTitle(postedRequestDisplay, shift, managerSetting);
        }
    }
    
    //Takes input string and assumes local timezone eg.Nov 5th 19:00 -> Nov 5 19:00 EST
    const shiftStartDateTimeAsDate = rawData.startDateForDisplay ? new Date(rawData.startDateForDisplay) : new Date(shift.startDateTime);

    let startDate = shiftStartDateTimeAsDate;
    let endDate = shiftStartDateTimeAsDate;
    if (isMonthly && isShiftOrPaycode) {
        let seconds = 1;
        if (typeNum === '1') {
            seconds = 2;
        }
        shiftStartDateTimeAsDate.setHours(0);
        shiftStartDateTimeAsDate.setMinutes(0);
        shiftStartDateTimeAsDate.setSeconds(seconds);
        startDate = shiftStartDateTimeAsDate;
        endDate = shiftStartDateTimeAsDate;
    }
    return {
        id: id,
        calendarId: typeNum,
        managerSettingId: rawData.managerSettingId,
        title: label,
        category: 'time',
        start: startDate,
        end: endDate,
        isReadOnly: true,
        raw: {
            ...rawData,
            source,
            isAvailableOffer,
            isOwnProposals,
            managerSettingName: managerSetting?.name,
            requestSubtype: managerSetting?.requestSubtype,
        },
        color: color,
        isVisible,
        isSkipValidation
    };
}

// TODO: Turn this into
export function buildDailyShiftSegments(shift) {
    const shiftStartDate = moment.utc(shift.startDateTime)
    const shiftEndDate = moment.utc(shift.endDateTime)
    const segments = shift.segments.filter(segment =>
        moment.utc(segment.startDateTime).isBetween(shiftStartDate, shiftEndDate, null, '[)')
    )

    const segmentText = (index, segment) => {
        return `${index + 1}.${getAsTimeFormat(segment.startDateTime)}
          [${moment.duration(moment.utc(segment.endDateTime).diff(moment.utc(segment.startDateTime))).asHours().toFixed(2)}h]
          ${segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT ? ' Transfer (x)' : (segment.type === ShiftSegmentTypeName.BREAK_SEGMENT) ? ' Break' : ''}
          `
    }

    return (
        <Grid container>
            {segments.map((segment, index) => {
                return (
                <React.Fragment>
                    <Grid item xs={12}>
                        {segmentText(index, segment)}
                    </Grid>
                    {
                        segment.shortOrgJobPath && (
                            <Grid item xs={12} style={{ paddingLeft: 16, marginBottom: 2 }}>
                                {segment.shortOrgJobPath}
                            </Grid>
                        )
                    }
                    {
                        segment.costCenter && (
                            <Grid item xs={12} style={{ paddingLeft: 16, marginBottom: 2 }}>
                                {
                                    segment.costCenter.costCenter.qualifier
                                }
                            </Grid>
                        )
                    }
                    {
                        segment.workruleRef && segment.workruleRef?.qualifier !== segment.primaryWorkruleRef?.qualifier && (
                            <Grid item xs={12} style={{ paddingLeft: 16, marginBottom: 2 }}>
                                {
                                    segment.workruleRef.qualifier
                                }
                            </Grid>
                        )
                    }
                </React.Fragment>
            )})}
        </Grid>
    )
}
export function buildShiftTooltip(shift, isOpenShift = false, availableOpenShifts = 0, isOpenShiftSignUp = false, hasTransfer = false) {
    const shiftInf = (
        <div className={'margin-bottom'}>
            <div className={clsx('common-popover', 'border-left', 'tooltip-header')}>
                {(shift.label) ? shift.label : ''} {getAsLongDate(shift.startDateTime)}
                {isOpenShiftSignUp && <AssignmentTurnedIn />}
                {hasTransfer ? <CompareArrowsIcon /> : <></>}
            </div>
            <div className={clsx('common-popover', 'border-left', 'tooltip-sub')}>
                {getAsStartAndEndTimeFormat(shift.startDateTime, shift.endDateTime)}
            </div>
            {isOpenShift ?
                <div className={clsx('common-popover', 'border-left', 'tooltip-sub')}>
                    Available shifts: {availableOpenShifts}
                </div>
                :
                null
            }
        </div>
    );

    // TODO: Ensure that shift objects are consistent (Write a mapping of all responses to test)
    let content = (
        <div className={'body-container'}>
            {shiftInf}
            <div className={clsx('margin-top', 'margin-bottom')}>
                <div className={clsx('tooltip-info', 'margin-bottom')}>
                    Segments
                </div>
                {!Aux.isNullOrUndefined(shift.segments) &&
                    shift.segments.map((segment, index) => (
                        <div key={index}>
                            <div className={clsx('left-container-info')}>
                                <div> {index + 1}. {getAsTimeFormat(segment.startDateTime)}
                                    [{moment.duration(moment.utc(segment.endDateTime).diff(moment.utc(segment.startDateTime))).asHours().toFixed(2)}h]
                                    {segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT ? ' Transfer (x)' : (segment.type === ShiftSegmentTypeName.BREAK_SEGMENT) ? ' Break' : ''}</div>
                            </div>
                            {segment.orgJobRef ? <div className={clsx('shift-path-container', 'border-left', 'padding-left')}>{segment.shortOrgJobPath}</div> : ''}
                            {segment.costCenter ? <div className={clsx('shift-path-container', 'border-left', 'padding-left')}>{segment.costCenter.costCenter.qualifier}</div> : ''}
                            {segment.workruleRef && segment.workruleRef?.qualifier !== segment.primaryWorkruleRef?.qualifier ? <div className={clsx('shift-path-container', 'border-left', 'padding-left')}>{segment.workruleRef.qualifier}</div> : ''}
                        </div>)
                    )}
            </div>
        </div>
    )
    return content;
}

const buildShiftInfo = (shift) => {
    const segments = shift.segments;
    return (
        <React.Fragment>
            <div className={'margin-bottom'}>
                <div className={clsx('border-left')} style={{ fontSize: '16px !important', fontWeight: 700 }}>
                    {(shift.label) ? shift.label : ''} {getAsLongDate(shift.startDateTime)}
                </div>
                <div className={clsx('border-left')} style={{ fontSize: '12px !important', fontWeight: 500 }}>
                    {getAsStartAndEndTimeFormat(shift.startDateTime, shift.endDateTime)}
                </div>
            </div>
            <div className={clsx('margin-top', 'margin-bottom')}>
                <div className={clsx('tooltip-info', 'margin-bottom')}>
                    Segments
                </div>
                {segments &&
                    segments.map((segment, index) => (buildSegmentInfo(segment, index))
                    )}
            </div>
        </React.Fragment>
    )
}

/**
 * @param {ApiManager.Segments} segment 
 * @param {number} index 
 */
export const buildSegmentInfo = (segment, index) => (
    <div key={index}>
        <div className={clsx('left-container-info')}>
            <div> {index + 1}. {getAsTimeFormat(segment.startDateTime)} &nbsp;
                [{moment.duration(moment.utc(segment.endDateTime).diff(moment.utc(segment.startDateTime))).asHours().toFixed(2)}h]
                {segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT ? ' Transfer (x)' : (segment.type === ShiftSegmentTypeName.BREAK_SEGMENT) ? ' Break' : ''}</div>
        </div>
        {segment.orgJobRef ? <div className={clsx('shift-path-container', 'border-left', 'padding-left')}>{segment.shortOrgJobPath}</div> : ''}
        {segment.costCenter ? <div className={clsx('shift-path-container', 'border-left', 'padding-left')}>{segment.costCenter.costCenter.qualifier}</div> : ''}
        {segment.workruleRef && segment.workruleRef?.qualifier !== segment.primaryWorkruleRef?.qualifier ? <div className={clsx('shift-path-container', 'border-left', 'padding-left')}>{segment.workruleRef.qualifier}</div> : ''}
    </div>
);

// TODO - Add typings here, whenever possible.
export function buildOfferTooltip(schedule, status, isSignUp = false) {
    let offerInfo = schedule.raw;
    let shiftInfo = '';
    let shift = getOfferShiftInfo(schedule);

    if (shift) {
        shiftInfo = buildShiftInfo(shift);
    }

    let content = (
        <div className={'body-container'}>
            <div className={clsx('border-left', 'tooltip-sub', 'margin-bottom')}>
                {offerInfo.managerSettingName}
                {isSignUp && <AssignmentTurnedIn className="offerTooltipSignUpIcon"/>}
            </div>
            <div className={clsx('border-left', 'tooltip-sub', 'margin-bottom')}>
                Status: {status}
            </div>
            {
                offerInfo.offerDate ?
                    <div className={clsx('border-left', 'margin-bottom')}>
                        Offer Date: {getAsLongDate(offerInfo.offerDate)}
                    </div> : null
            }

            {offerInfo.employeeToName && offerInfo.requestDate ? <div className={clsx('border-left')}>
                Request Date: {getAsLongDate(offerInfo.requestDate)}
            </div> : ''}
            {shiftInfo}
        </div>

    )
    return content;
}

// TODO - Add typings here, whenever possible.
export function getOfferShiftInfo(schedule) {
    let offerInfo = schedule.raw
    let shift = null;

    const scheduleStart = formatAs(schedule.start, DateFnsFormats.ISO);
    if (offerInfo.shift) {
        shift = offerInfo.isPartial ? offerInfo.partialShift : offerInfo.shift
    } else if (offerInfo.shifts) {
        if (schedule.raw.isAvailableOffer || schedule.raw.source === RequestSource.Offerer) {
            if (schedule.raw.isPartial) {
                shift = offerInfo.partialShift;
            }
            else {
                shift = offerInfo.shifts.find(shift => moment.utc(shift.startDateTime).isSame(moment.utc(scheduleStart), 'd'))
            }
        }
        else if (offerInfo.proposals && offerInfo.proposals.length > 0) {
            const proposal = offerInfo.proposals[0];
            if (proposal.isPartial) {
                shift = proposal.partialShift;
            }
            else {
                shift = proposal.shifts.find(shift => moment.utc(shift.startDateTime).isSame(moment.utc(scheduleStart), 'd'));
            }
        }
    }

    return shift;
}

export const getPaycodeTimePeriod = ({ startDateTime, endDateTime, durationInTime }) =>
    (!!startDateTime && !!endDateTime && durationInTime)
        ? getAsStartAndEndTimeFormat(startDateTime, endDateTime)
        : '';

export function buildPaycodeTooltip(
    paycode,
    duration,
) {
    if (!Object.keys(paycode || {}).length) {
        return <></>;
    }

    const { payCodeRef: { qualifier } } = paycode;
    const timeRange = getPaycodeTimePeriod(paycode);

    return (
        <div className={'body-container'}>
            <div className={'margin-bottom'}>
                <div className={clsx('common-popover', 'border-left', 'tooltip-sub')}>
                    {qualifier} ({duration})
                </div>
                <div className='tooltip-sub'>
                    {timeRange}
                </div>
            </div>
        </div>
    );
}

export function generateListSelect(data, submitButton, shiftsArray) {
    const { classes, managerSettings, proposalPartialDates, updateProposalPartialDates, storeData, updateProposalShiftsSelected, mobileProposalShiftsSelected } = this.props;
    const setting = managerSettings.find(setting => setting.aggregateRootId === data.raw.managerSettingAggregateRootId);
    const isPartialEnabledInSetting = setting.isPartialShiftEnabled;
    const sliderPartialRequestWithLabelProps = {
        storeData,
        requestType: RequestTypes.shiftSwap,
        handleChange: (e, val, shifts, requestType) => handleChangeProposalPartial(updateProposalPartialDates, e, val, shifts, requestType),
        selectedPartial: proposalPartialDates.partialShiftLabel,
    }
    return (<React.Fragment>
        <Grid spacing={0} fixed container alignItems="flex-start" justifyContent="space-between" direction="row">
            <div style={{ width: '612.5px' }} className={classes.sidebarActionContainer}>
                {submitButton}
            </div>
            <Grid item xs={12} style={{ maxHeight: 'calc(100vh - 114px)', overflow: 'auto', marginTop: 57 }}>
                <ListSelect shiftsArray={_.sortBy(shiftsArray, ['fullTime'])} selection={mobileProposalShiftsSelected.map(x => x.id)}
                    handlerUpdateState={(update) => { updateProposalShiftsSelected(shiftsArray.filter(shift => update.includes(shift.id))) }}
                    isPartialEnabledInSetting={isPartialEnabledInSetting} offeredShiftsCount={data.shifts.length} sliderPartialRequestWithLabelProps={sliderPartialRequestWithLabelProps} />
            </Grid>
        </Grid>
    </React.Fragment>
    )
}

function generateRequestCreation(
    data,
    submitButton,
    selectedPartial,
    handleChange = () => { },
    classes,
    timeOffRequestSubtypeIdSelected,
    timeOffRequestReasonIdSelected,
    updateStateSubtypeId,
    updateStateReasonId,
    setPrivateEmployeeWarning,
) {
    const {
        selectedActionIndex,
        billboardActions,
        employeesToOfferList,
        managerSettings,
        t,
        sidePanelData,
        timeOffRequestSubtypes,
        storeData,
    } = this.props;

    let { isSendToPrivate } = this.state;

    let selectedEmployeeList = [];
    let selectedManagerSetting;
    let actionIsSelected = selectedActionIndex >= 0

    if (actionIsSelected) {
        selectedManagerSetting = managerSettings.find(setting => setting.id === billboardActions[selectedActionIndex]?.value)
        if (employeesToOfferList) {
            selectedEmployeeList = _.uniqBy(employeesToOfferList.employees, 'employeeId')
        }
    } else {
        selectedManagerSetting = { type: -1 } // No settings selected
        selectedEmployeeList = [];
    }

    const paddingContainer = { padding: '8px 24px' };
    const submitButtonStyle = {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        ...paddingContainer,
    };

    // Find the selected manager setting
    // Determine the action type
    let i = 1;
    switch (selectedManagerSetting.type) {
        case RequestTypes.toCover: {
            return (
                <div style={paddingContainer}>
                    <div>
                        <div style={{ marginBottom: 8 }}>
                            <NumberedStepContainer stepNumber={i++} classes={classes} title={t('billboard.selectRequestType')}>
                                <RequestSelectionStep
                                    classes={classes}
                                    billboardActions={billboardActions}
                                    selectedActionIndex={selectedActionIndex}
                                    sidePanelData={sidePanelData}
                                    onChange={this.handleSubmitActionType}
                                />
                            </NumberedStepContainer>
                        </div>
                        {
                            (data.shifts.length === 1 && selectedManagerSetting.isPartialShiftEnabled) && (
                                <div
                                    style={{
                                        maxHeight: 300,
                                        marginBottom: 8,
                                    }}
                                >
                                    <SliderPartialRequestWrapper
                                        shifts={data.shifts}
                                        storeData={storeData}
                                        selectedPartial={selectedPartial}
                                        handleChange={handleChange}
                                        index={i++}
                                        classes={classes}
                                        requestType={RequestTypes.toCover}
                                    />
                                </div>
                            )
                        }
                        <div
                            style={{
                                overflowY: 'auto',
                                marginBottom: 8,
                            }}
                        >
                            {generateSendToPrivateToggle.bind(this)()}
                            {isSendToPrivate && employeeListSection.bind(this)(i++, selectedEmployeeList, setPrivateEmployeeWarning)}
                        </div>                          
                        <div style={{ marginBottom: 8 }}>
                            {(selectedManagerSetting.timeOffRequestCreationType == TorCreationType.Optional || selectedManagerSetting.timeOffRequestCreationType == TorCreationType.Required ) && (
                                <NumberedStepContainer
                                    title={selectedManagerSetting.timeOffRequestCreationType == TorCreationType.Optional ? 
                                        t('billboard.createTimeOffRequestOptional') : 
                                        t('billboard.createTimeOffRequest')
                                    }
                                    stepNumber={i++}
                                    classes={{ ...classes, title: classes.sidePanelStepHeader }}
                                >
                                    <TimeOffRequestCreationStep
                                        updateStateSubtypeId={updateStateSubtypeId}
                                        updateStateReasonId={updateStateReasonId}
                                        timeOffRequestSubtypeIdSelected={timeOffRequestSubtypeIdSelected}
                                        timeOffRequestReasonIdSelected={timeOffRequestReasonIdSelected}
                                        options={selectedManagerSetting.timeOffRequestCreationType == TorCreationType.Required ? 
                                            timeOffRequestSubtypes.filter(option => option.id !== null) : 
                                            timeOffRequestSubtypes
                                        }
                                    />
                                </NumberedStepContainer>)}
                        </div>
                    </div>
                    <div style={submitButtonStyle}>
                        {submitButton}
                    </div>
                </div>
            )
        }
        case RequestTypes.shiftSwap:
            return (
                <div style={paddingContainer}>
                    <div>
                        <div style={{ marginBottom: 8 }}>
                            <NumberedStepContainer stepNumber={i++} classes={classes} title={t('billboard.selectRequestType')}>
                                <RequestSelectionStep
                                    classes={classes}
                                    billboardActions={billboardActions}
                                    selectedActionIndex={selectedActionIndex}
                                    sidePanelData={sidePanelData}
                                    onChange={this.handleSubmitActionType}
                                />
                            </NumberedStepContainer>

                        </div>
                        {
                            (data.shifts.length === 1 && selectedManagerSetting.isPartialShiftEnabled) && (
                                <div
                                    style={{
                                        maxHeight: 300,
                                        marginBottom: 8,
                                    }}
                                >
                                    <SliderPartialRequestWrapper
                                        shifts={data.shifts}
                                        storeData={storeData}
                                        selectedPartial={selectedPartial}
                                        handleChange={handleChange}
                                        index={i++}
                                        classes={classes}
                                        requestType={RequestTypes.shiftSwap}
                                    />
                                </div>
                            )
                        }
                        {
                            !!actionIsSelected && (
                                <div>
                                    {generateSendToPrivateToggle.bind(this)()}
                                    <div
                                        style={{
                                            overflowY: 'auto',
                                            marginBottom: 8,
                                        }}
                                    >
                                        {
                                            (isSendToPrivate && !selectedManagerSetting.isAllowProposalWithOffer) &&
                                            employeeListSection.bind(this)(i++, selectedEmployeeList, setPrivateEmployeeWarning)
                                        }
                                        {
                                            (isSendToPrivate && selectedManagerSetting.isAllowProposalWithOffer) &&
                                            employeesWithShiftsSection.bind(this)(i++, selectedEmployeeList, setPrivateEmployeeWarning, selectedManagerSetting.isPartialShiftEnabled)
                                        }
                                    </div>
                                </div>
                            )
                        }
                        {
                            (selectedManagerSetting.isShiftSwapEmployeePreferencesEnabled)
                            && (
                                <div style={{ marginBottom: 8 }}>
                                    {selectPreferredDatesSection.bind(this)(i++, data)}
                                </div>
                            )
                        }
                    </div>
                    <div style={submitButtonStyle}>
                        {submitButton}
                    </div>
                </div>
            )
        default:
            return (
                <div style={paddingContainer}>
                    <div>
                        <div>
                            <div style={{ marginBottom: 8 }}>
                                <NumberedStepContainer stepNumber={i++} classes={classes} title={t('billboard.selectRequestType')}>
                                    <RequestSelectionStep
                                        classes={classes}
                                        billboardActions={billboardActions}
                                        selectedActionIndex={selectedActionIndex}
                                        sidePanelData={sidePanelData}
                                        onChange={this.handleSubmitActionType}
                                    />
                                </NumberedStepContainer>
                            </div>
                            {
                                !!actionIsSelected && (
                                    <div
                                        style={{
                                            overflowY: 'auto',
                                        }}>
                                        {generateSendToPrivateToggle.bind(this)()}
                                        {isSendToPrivate && employeeListSection.bind(this)(i++, selectedEmployeeList, setPrivateEmployeeWarning)}
                                    </div>
                                )
                            }
                        </div>
                    </div>
                    <div style={submitButtonStyle}>
                        {submitButton}
                    </div>
                </div>
            )
    }
}

function selectPreferredDatesSection(index, data) {
    const { classes } = this.props;

    return (
        <NumberedStepContainer
            title={'Select preferred dates (optional)'}
            stepNumber={index}
            classes={{ ...classes, title: classes.sidePanelStepHeader }}
        >
            <MultipleDayPicker
                callback={(selected) => {
                    this.setState({
                        preferredDatesSelected: selected
                    })
                }}
                selectedDays={[]}
                isReadOnly={false}
                containerStyle={classes.preferredDayPickerContainer}
            >
            </MultipleDayPicker>
        </NumberedStepContainer>
    )
}

function employeeListSection(index, selectedEmployeeList, setPrivateEmployeeWarning = () => {}) {
    const { classes, t } = this.props;
    
    return (
        <NumberedStepContainer
            title={'Send request to specific employees (optional)'}
            stepNumber={index}
            classes={{ ...classes, title: classes.sidePanelStepHeader }}
            isCollapsable
            expanded={true}
        >
            <SearchMultiSelect 
                handleSelection={(update) => {
                    this.setState({ employeesSelected: update });
                }}
                selection={this.state.employeesSelected}
                displayList={!_.isEmpty(selectedEmployeeList)
                    ? selectedEmployeeList.sort((a, b) =>
                        a.firstName ? a.firstName.localeCompare(b.firstName) : -1
                    )
                    : []
                }
                getEmployeesToOffer={this.fetchPrivateEmployees}
                handleFilterChange={this.handleFilterChange}
                isShowPreview
                onClick={(employee) => {
                    if (!employee.isValidated) {
                        this.validateEmployeePriority(employee.employeeId);
                    }
                    if (!employee.isValid) {
                        setPrivateEmployeeWarning(
                            `The employee ${employee.label} is not selectable due to a failing validation rule (${t(`employee.validationError.${ValidationTypeName[employee.failedValidationTypeId]}`)}).`
                        );
                    }
                }}
                isShowWarnings={this.state.privateEmployeeFilters.isShowWarnings}
            />
        </NumberedStepContainer>
    );
}

function employeesWithShiftsSection(index, selectedEmployeeList, setPrivateEmployeeWarning = () => {}, isPartialShiftEnabled) {
    const { classes, sidePanelData, t } = this.props;
    return (
        <NumberedStepContainer
            title={'Send request with specific shifts to a specific employee (optional)'}
            stepNumber={index}
            classes={{ ...classes, title: classes.sidePanelStepHeader }}
            isCollapsable
            expanded={true}
        >
            <EmployeeProposableShifts
                getEmployeeProposableShifts={(employeeId, isSkipValidation) => this.fetchPrivateEmployeeProposableShifts(employeeId, isSkipValidation)}
                offeredShiftsCount={sidePanelData.shifts.length}
                getEmployeesToOffer={this.fetchPrivateEmployees}
                onClick={(employee) => {
                    if (!employee.isValidated) {
                        this.validateEmployeePriority(employee.employeeId);
                    }
                    if(!employee.isValid) setPrivateEmployeeWarning(`The employee ${employee.firstName} ${employee.lastName} is not selectable due to a failing validation rule (${t(`employee.validationError.${ValidationTypeName[employee.failedValidationTypeId]}`)}).`)
                }}
                isPartialShiftEnabled={isPartialShiftEnabled}
                handleFilterChange={this.handleFilterChange}
                isShowWarnings={this.state.privateEmployeeFilters.isShowWarnings}
            />
        </NumberedStepContainer>
    );
}

function generateSendToPrivateToggle() {
    const { classes } = this.props
    const { isSendToPrivate } = this.state
    return (
        <Card className={classes.cards}>
            <CardContent className={classes.sendToPrivateToggleCardContent}>
                <FormControl component="fieldset">
                    <RadioGroup
                        row
                        value={isSendToPrivate ? 'private' : 'billboard'}
                        onChange={(event) => {
                            const shouldSendToPrivate = event.target.value === 'private';
                            if (shouldSendToPrivate !== isSendToPrivate) {
                                this.onTogglePrivateEmployees();
                            }
                        }}
                    >
                        <FormControlLabel 
                            value="billboard" 
                            control={<Radio color="primary" />} 
                            label="Send to billboard" 
                        />
                        <FormControlLabel 
                            value="private" 
                            control={<Radio color="primary" />} 
                            label="Send to private employees" 
                        />
                    </RadioGroup>
                </FormControl>
            </CardContent>
        </Card>
    )
}

/*
const convertOutOfTimezoneOffset = (dateTime) => {
    return moment.parseZone(dateTime).utc().format();
}
*/
// For a future update. This renders the label with the time on the slider
// const valueLabelFormat = (value, marks) => {
//     let label = moment.utc(convertOutOfTimezoneOffset(marks.find(mark => mark.value === value).time)).format('h:mm A')
//     return (
//         <div style={{
//             fontSize: 9,
//             textAlign: 'center',
//         }}>
//             {label}
//         </div>
//     );
// }

// For a future update. This is to generate the marks on the slider
// const calculateMarks = (shift, segment = false) => {
//     if (segment) {

//     } else {
//         let initial = moment(shift.startDateTime, 'YYYY-MM-DD hh:mm:ss').startOf('minute');
//         let endDateTime = moment(shift.endDateTime, 'YYYY-MM-DD hh:mm:ss').startOf('minute');
//         let firstHour = initial.minute() === 0 ? initial : moment(shift.startDateTime, 'YYYY-MM-DD hh:mm:ss').startOf('hour').add(1, 'h')
//         let firstStep = (moment.duration(firstHour.diff(initial)).asMinutes()) / 5;
//         let maxNumberSteps = Math.ceil((this.state.max - firstStep) / 12);
//         // return initial.isSame(endDateTime, 'd') ? this.getStepsDiffDay(maxNumberSteps, firstStep, firstHour) : this.getStepsSameDay(maxNumberSteps, firstStep)
//     }
// }


export function generateProposalCards(offerId, proposals, acceptHandler, rejectHandler, submitButton, displayButton = true, hasActions = false) {
    return (
        <Grid container>
            <Grid style={{ padding: '1vh 1vw' }} spacing={0} fixed container alignItems="flex-start" justifyContent="space-between" direction="row">
                <Grid item md={6}>
                    <Typography variant='h6' style={{ fontWeight: 'bold' }}>
                        {hasActions ? `Your offers (${proposals.length})` : 'Proposal'}
                    </Typography>
                </Grid>
                <Grid item style={{ display: 'flex' }}>
                    {displayButton ? submitButton : null}
                </Grid>
                <Grid item xs={12} style={{ maxHeight: 'calc(98vh - 89px)', overflow: 'auto' }}>
                    <ProposalCard hasActions={hasActions} proposals={proposals.map(ele => Aux.formatProposalData(ele, offerId))} handleAcceptButton={acceptHandler} handleRejectButton={rejectHandler} />
                </Grid>
            </Grid>

        </Grid>
    )
}

export function generateProposalCardsMadeByOfferor(offer, proposals, submitButton) {
    return (
        <Grid container>
            <Grid style={{ padding: '1vh 1vw' }} spacing={0} fixed container alignItems="flex-start" justifyContent="space-between" direction="row">
                <Grid item md={6}>
                    <Typography variant='h6' style={{ fontWeight: 'bold' }}>
                        Selected shifts
                    </Typography>
                </Grid>
                <Grid item md={6} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    {submitButton}
                </Grid>
                <Grid item xs={12} style={{ maxHeight: 'calc(98vh - 89px)', overflow: 'auto' }}>
                    <ProposalCard proposals={proposals.map(ele => Aux.formatProposalDataWithCustomName(ele, offer.raw.offerorEmployeeName))} />
                </Grid>
            </Grid>

        </Grid>
    )
}

export function wrapWithLeftRightGrid(data, classes, isWrapped, submitButton, shiftList = [], selectedPartialLabel = '', handleChangePartial, timeOffRequestSubtypeIdSelected, timeOffRequestReasonIdSelected, updateStateSubtypeId, updateStateReasonId, privateEmployeeWarning, setPrivateEmployeeWarning, handleFilterChange) {
    let leftContainer = '';
    let rightContainer = '';

    if (data.type === RequestTypes.voluntaryTimeOff) {
        rightContainer = generateVTOInformation.bind(this)(classes, data, submitButton, isWrapped)
    }
    else if (data.type === RequestTypes.openShift && data.requestSubtype === RequestSubtypes.signUp) { // Advanced open shift with awarding
        rightContainer = generateAdvancedOSInformation.bind(this)(submitButton, data)
    }
    else {
        rightContainer = generateShiftInformation.bind(this)(classes, data, submitButton, isWrapped, privateEmployeeWarning)
    }

    if (isWrapped) {
        switch (data.type) {
            case -1:
                leftContainer = generateRequestCreation.bind(this)(
                    data,
                    submitButton,
                    selectedPartialLabel,
                    handleChangePartial,
                    classes,
                    timeOffRequestSubtypeIdSelected,
                    timeOffRequestReasonIdSelected,
                    updateStateSubtypeId,
                    updateStateReasonId,
                    setPrivateEmployeeWarning,
                    handleFilterChange
                );
                break;
            case RequestTypes.shiftSwap:
                switch (data.status) {
                    case RequestStatus.Offered:
                        if (data.source === RequestSource.Offerer) {//my swap offers
                            if (data.raw.isProposedByOfferer) {
                                leftContainer = generateProposalCardsMadeByOfferor(data, data.proposals.filter(ele => ele.status === RequestStatus.Offered), null);
                            }
                            else {
                                leftContainer = generateProposalCards(data.offerId, data.proposals.filter(ele => ele.status === RequestStatus.Offered),
                                    (pId) => this.handleSelectProposal(pId),
                                    (pId) => handleRejectProposal(this, pId, data), submitButton, false, true);
                            }
                            rightContainer = generateShiftInformation.bind(this)(classes, data, submitButton, false)
                        } else if (data.source === RequestSource.Requester) {//avail offers, my proposals, 
                            if (data.raw.isAvailableOffer
                                || (data.raw.isPrivate
                                    && !data.raw.isProposedByOfferer
                                    && data.raw.proposals.every(x => ![RequestStatus.Offered, RequestStatus.Submitted, RequestStatus.Pending].includes(x.status)))) {
                                // Show shifts to employee to make proposal:
                                leftContainer = generateListSelect.bind(this)(data, submitButton, shiftList)
                            }
                            else if (data.raw.isPrivate && data.raw.isProposedByOfferer && data.raw.proposals.some(x => x.status === RequestStatus.Offered)) {
                                // Show proposal made by offeror:
                                let proposalsToDisplay = data.proposals.length < 2 ? data.proposals : data.proposals.slice(-1);
                                leftContainer = generateProposalCardsMadeByOfferor(data, proposalsToDisplay, submitButton);
                            }
                            else {//EE2 in SS, show past proposals
                                let proposalsToDisplay = data.proposals.length < 2 ? data.proposals : data.proposals.slice(-1);
                                leftContainer = generateProposalCards(data.offerId, proposalsToDisplay,
                                    (pId) => this.handleSelectProposal(pId),
                                    (pId) => handleRejectProposal(this, pId, data), submitButton, false);
                                rightContainer = generateShiftInformation.bind(this)(classes, data, submitButton, false)
                            }
                        }
                        break;
                    default:
                        if (data.raw.isProposedByOfferer) {
                            leftContainer = generateProposalCardsMadeByOfferor(data, data.proposals, submitButton);
                        }
                        else {
                            leftContainer = generateProposalCards(data.offerId, data.proposals,
                                (pId) => this.handleSelectProposal(pId),
                                (pId) => handleRejectProposal(this, pId, data), submitButton);
                        }
                        break;
                }
                break;
            case RequestTypes.openShift: // Open shifts with partial enabled
                const {
                    storeData,
                } = this.props;
                const getOverlapDataFromSameOpenShift = (shift) => {
                    const shiftSelected = storeData.myOpenShiftRequests.find(x => x.isPartial && x.shift.id === shift.id);
                    let storeDataFromSameOpenShift = {};
                    if (!!shiftSelected) {
                        storeDataFromSameOpenShift.miscellaneousOffers = [
                            {
                                alreadyOfferedInPartialStart: shiftSelected.partialShift.startDateTime,
                                alreadyOfferedInPartialEnd: shiftSelected.partialShift.endDateTime,
                            }
                        ];
                    }
                    return storeDataFromSameOpenShift;
                }
                leftContainer = (
                    <React.Fragment>
                        <div style={{ height: '90%', padding: '12px 26px' }}>
                            <Grid container alignItems='flex-start'>
                                <Grid item xs={12} style={{ maxHeight: 300, marginBottom: 8 }}>
                                    <SliderPartialRequestWrapper
                                        shifts={data.shifts}
                                        storeData={getOverlapDataFromSameOpenShift(data.shifts[0])}
                                        selectedPartial={selectedPartialLabel}
                                        handleChange={handleChangePartial}
                                        index={1}
                                        classes={classes}
                                        requestType={RequestTypes.openShift}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <div style={{ height: '10%', padding: '12px 26px' }}>
                            <Grid container>
                                <Grid item xs={12} style={{ display: 'flex' }}>
                                    {submitButton}
                                </Grid>
                            </Grid>
                        </div>
                    </React.Fragment>
                )
                break;
            case RequestTypes.voluntaryTimeOff: // VTO with partial enabled
                const {
                    storeData: vtoStoreData,
                } = this.props;
                // Create a pseudo-shift object for VTO using the VTO period dates
                const vtoShift = {
                    startDateTime: data.raw.timeOffStartDate,
                    endDateTime: data.raw.timeOffEndDate,
                    segments: []
                };
                // Get affected shifts to display as visual indicators
                //const vtoAffectedShifts = data.raw.affectedShifts || [];

                leftContainer = (
                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <div style={{ flex: '1 1 auto', padding: '12px 26px', overflowY: 'auto' }}>
                            <Grid container alignItems='flex-start'>
                                <Grid item xs={12} style={{ marginBottom: 8 }}>
                                    <SliderPartialRequestWrapper
                                        shifts={[vtoShift]}
                                        storeData={vtoStoreData}
                                        selectedPartial={selectedPartialLabel}
                                        handleChange={handleChangePartial}
                                        index={1}
                                        classes={classes}
                                        requestType={RequestTypes.voluntaryTimeOff}
                                        //employeeSchedule={vtoAffectedShifts}
                                        color="#006600"
                                        managerSettingEntityId={data.managerSetting.id}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                        <div style={{ flex: '0 0 auto', padding: '12px 26px', borderTop: '1px solid #e0e0e0' }}>
                            <Grid container>
                                <Grid item xs={12} style={{ display: 'flex' }}>
                                    {submitButton}
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                )
                break;
            default:
                break;
        }
        return (
            <Grid container className={classes.sidebarExtendedContainer}>
                <Grid item xs={7} className={classes.sidebarLeftContainer}> {/*Left side of the side panel*/}
                    {leftContainer}
                </Grid>
                <Grid item xs={5} className={classes.sidebarRightContainer}> {/*Right side of the side panel*/}
                    {rightContainer}
                </Grid>
            </Grid>
        )
    }
    return (
        <Grid container className={classes.sidebarContainer}>
            <Grid item xs={12} className={classes.sidebarRightContainer}>{rightContainer}</Grid>
        </Grid>
    );
}

function generateAdvancedOSInformation(submitButton, data) {
    const { classes, sidePanelData } = this.props
    const warning = `Sign up limit is ${formatAs(sidePanelData.managerSetting.toCoverPeriod_EndDate, DateFnsFormats.VERBOSE_LONG_DATETIME_FORMAT)}`
    const columns = [
        {
          title: 'Date',
          field: 'startDateTime',
          render: (row) => getAsLongDate(row.startDateTime),
        },
        {
          title: 'Shift',
          field: 'label',
          render: (row) => {
            const transferExists = row.segments.find(segment => segment.type === ShiftSegmentTypeName.TRANSFER_SEGMENT);
            const dateTimeRange = getAsStartAndEndTimeFormat(row.startDateTime, row.endDateTime);
            return `${row.label ?? ''} ${dateTimeRange}${transferExists ? ' (x)' : ''}`;
          },
        },
    ];

    return (
        <div style={{ height: 'calc(100vh - 57px)', backgroundColor: '#FFFFFF', padding: 5, overflow: 'hidden' }}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                <div>
                        <CollapsibleTable
                            data={data.shifts}
                            columns={columns}
                            renderDetails={(row) => (
                                <div>
                                <Typography variant="h6" gutterBottom component="div">
                                    Segments
                                </Typography>
                                {buildDailyShiftSegments(row)}
                                </div>
                            )}
                            defaultOpen={true}
                        />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <SidePanelDetails
                        isShowManagerMessage
                        managerMessage={sidePanelData.details}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography component='div' style={{ width: '100%', padding: '5px 10px', backgroundColor: '#FFFFFF', border: '1px solid #FF7300', borderRadius: 4 }}>
                        <FontAwesomeIcon icon={faExclamation} /> {warning}
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    {submitButton}
                </Grid>
            </Grid>
        </div>
    )
}

/**
 * @param {typeof TimeOffType[keyof typeof TimeOffType]} timeOffType
 * @param {Date} timeOffStartDate
 * @param {Date=} timeOffEndDate
 */
export const getVtoTimeOffPeriodLabel = (timeOffType, timeOffStartDate, timeOffEndDate) => {
    switch (timeOffType) {
        case TimeOffType.SingleDay:
            return ` ${getAsLongDate(timeOffStartDate)}`;
        case TimeOffType.BlockOfDays:
            return ` ${formatDateRange(timeOffStartDate, timeOffEndDate, getAsLongDate)}`;
        case TimeOffType.TimePeriod:
            return ` ${formatDateRange(timeOffStartDate, timeOffEndDate, getAsLongDateTime)} `;
        default:
            return '';
    }
};

export function generateVTOInformation(classes, data, submitButton, isWrapped = false) {
    const vto = data.raw;
    const timeOffType = data.managerSetting.voluntaryTimeOffType;

    // Use partial dates if this is a partial VTO request, otherwise use full VTO period
    const startDate = data.isPartial && data.partialStartDate ? data.partialStartDate : vto.timeOffStartDate;
    const endDate = data.isPartial && data.partialEndDate ? data.partialEndDate : vto.timeOffEndDate;
    const timeoff = getVtoTimeOffPeriodLabel(timeOffType, startDate, endDate);

    const dates = timeoff ? (
        <>
            <FontAwesomeIcon icon={faCalendarAlt} className={classes.plusMinus} />
            {timeoff}
            {data.isPartial && <span style={{ marginLeft: 8, fontStyle: 'italic', color: '#666' }}>(Partial)</span>}
        </>
    ) : <></>;

    const warning = `Sign up limit is ${formatAs(vto.submissionEndDate, DateFnsFormats.VERBOSE_LONG_DATETIME_FORMAT)} `;
    const noShiftwarning = `No available shifts during the period`;
    const isSignUp = data.requestSubtype === RequestSubtypes.signUp;

    return (
        <div className={classes.vtoSidePanelSection}>
            <Grid container spacing={3}>
                {!isWrapped && submitButton && <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', padding: '12px 12px 0 0' }}>
                    {submitButton}
                </Grid>}
                <Grid item xs={12}>
                    <Typography variant='h6' style={{ fontWeight: 'bold', marginBottom: 5 }}>
                        Dates
                    </Typography>
                    <div style={{ width: '100%', padding: '5px 10px', backgroundColor: '#FFFFFF', border: '1px solid #E6EDF5', borderRadius: 4 }}>
                        {dates}
                    </div>
                </Grid>
                <Grid item xs={12} container style={{ marginLeft: -8 }}>
                    <SidePanelDetails
                        isShowManagerMessage
                        managerMessage={data.details}
                        isShowSubmissionPeriod={isSignUp}
                        submissionStartDate={getAsLongDateTime(vto.submissionStartDate)}
                        submissionEndDate={getAsLongDateTime(vto.submissionEndDate)}
                    />
                </Grid>
                {data.source === RequestSource.Requester && isSignUp ?
                    <Grid item xs={12}>
                        <Typography component='div' style={{ width: '100%', padding: '5px 10px', backgroundColor: '#FFFFFF', border: '1px solid #FF7300', borderRadius: 4 }}>
                            <FontAwesomeIcon icon={faExclamation} /> {warning}
                        </Typography>
                    </Grid> : null
                }
                {!data.isValid ?
                    <Grid item xs={12}>
                        <Typography component='div' style={{ width: '100%', padding: '5px 10px', backgroundColor: '#FFFFFF', border: '1px solid #EE0000', borderRadius: 4 }}>
                            <FontAwesomeIcon icon={faExclamationTriangle} /> {noShiftwarning}
                        </Typography>
                    </Grid> : null
                }
                <Grid item xs={12} container style={{ marginLeft: -8 }}>
                    {generateSidePanelHistory(data.history, this.props.managerSettingNames, classes)}
                </Grid>
            </Grid>
        </div>
    );
}

export function generateShiftInformation(classes, data, submitButton, isWrapped = false, privateEmployeeWarning = null) {
    let history = (data.history) ? data.history : [];

    const validationErrors = data.rawValidationDetails != null && data.rawValidationDetails !== undefined && data.rawValidationDetails.length > 0 ? data.rawValidationDetails.filter(x => !x.isValid) : [];
    const statusValidationErrors = data.statusValidationDetails != null && data.statusValidationDetails !== undefined && data.statusValidationDetails.length > 0 ? data.statusValidationDetails.filter(x => !x.isValid) : [];
    const isPartialShift = data.raw?.isPartial;

    const columns = [
        {
          title: 'Date',
          field: 'startDateTime',
          render: (row) => getAsLongDate(row.startDateTime),
        },
        {
          title: 'Shift',
          field: 'label',
          render: (row) => {
            const transferExists = row.segments.find((segment) => segment.type === 'TRANSFER_SEGMENT');
            const dateTimeRange = getAsStartAndEndTimeFormat(row.startDateTime, row.endDateTime);
            return `${row.label ?? ''} ${dateTimeRange}${transferExists ? ' (x)' : ''}`;
          },
        },
    ];

    return (
        <React.Fragment>
            {
                !isWrapped && submitButton ? <div className={classes.sidebarActionContainer}>
                    {submitButton}
                </div> : null
            }
            <Grid container>
                {data.employeeName ? <Grid style={{ marginBottom: '10px' }} item xs={12}><Typography component='h1' className={classes.shiftInfoHeader}>Owner</Typography></Grid> : <Grid item xs={12} style={{ paddingTop: 12 }}></Grid>}
                <Grid container spacing={3} style={{ margin: '-12px 0' }}>
                    {
                        data.employeeName ?
                            <React.Fragment>
                                <Grid item xs={2}><Avatar alt={`${data.employeeName} `} /></Grid>
                                <Grid item xs={10} className={classes.shiftInfoHeaderEmployeeNameWrapper}>
                                    <Typography component='div' className={classes.shiftInfoHeaderEmployeeName} >{data.employeeName}</Typography>
                                </Grid>
                            </React.Fragment>
                            :
                            <Grid item xs={10}></Grid>
                    }
                </Grid>
                <Divider style={{ margin: '10px 0', width: '100%' }} />
                <Grid item xs={12}>
                    <div>
                        <CollapsibleTable
                            data={data.shifts}
                            columns={columns}
                            renderDetails={(row) => (
                                <div>
                                <Typography variant="h6" gutterBottom component="div">
                                    Segments
                                </Typography>
                                {buildDailyShiftSegments(row)}
                                </div>
                            )}
                            defaultOpen={true}
                        />
                    </div>
                </Grid>
                <AvailableTimeOffRequest
                    timeOffRequest={data.timeOffRequest}
                    error={data.timeOffRequestError}
                />
                {(validationErrors.length + statusValidationErrors.length) > 0 ?
                    <React.Fragment>
                        <Divider style={{ margin: '10px 0', width: '100%' }} />
                        <Grid item xs={12}>
                            <Grid style={{ marginBottom: '10px' }} item xs={12}>
                                <Typography
                                    component='h1'
                                    className={classes.shiftInfoHeader}
                                >
                                    Rule violations
                                </Typography>
                            </Grid>
                            <ValidationErrorPanel
                                validationErrorsResponse={validationErrors}
                                statusValidationErrorsResponse={statusValidationErrors}
                            />
                        </Grid>
                    </React.Fragment>
                    : null}
                {!!privateEmployeeWarning ? (
                    <React.Fragment>
                        <Divider style={{ margin: '10px 0', width: '100%' }} />
                        <Grid item xs={12}>
                            <Grid style={{ marginBottom: '10px' }} item xs={12}>
                                <Typography
                                    component='h1'
                                    className={classes.shiftInfoHeader}
                                >
                                    Rule violations
                                </Typography>
                            </Grid>
                            <Grid style={{ marginBottom: '10px' }} item xs={12}>
                                <div style={{ padding: '8px' }}>
                                    <span> {privateEmployeeWarning} </span>
                                </div>
                            </Grid>
                        </Grid>
                    </React.Fragment>
                ) : null}
                {
                    data.type !== -1 ?
                        <Grid item xs={12}>
                            <Divider style={{ margin: '10px 0', width: '100%' }} />
                            <SidePanelDetails
                                isShowManagerMessage
                                managerMessage={data.details}
                                isShowSubmissionPeriod={!!data.submissionPeriod}
                                submissionStartDate={getAsLongDateTime(data.submissionPeriod?.startDate)}
                                submissionEndDate={getAsLongDateTime(data.submissionPeriod?.endDate)}
                                isShowRestrictionDates={!!data.restrictionDates}
                                restrictionStartDate={getAsLongDate(data.restrictionDates?.startDate)}
                                restrictionEndDate={getAsLongDate(data.restrictionDates?.endDate)}
                                restrictedEmployeeName={data.restrictionDates?.employeeName}
                            />
                        </Grid>
                        :
                        null
                }

                {generateSidePanelPreferedDates.bind(this)(data)}
                {generateSidePanelRecipients.bind(this)(data)}
                {generateSidePanelHistory(history, this.props.managerSettingNames, classes)}
            </Grid>
        </React.Fragment>

    );
}

/**
 * @brief Return array of schedules for the TUI Calendar to read
 *
 * @param {Boolean} isMonthly
 * @param {array} employeeShifts
 * @param {array} employeeShiftOffers
 * @param {array} availableOffers
 * @param {array} submittedRequests
 * @param {array} historyLog
 * @param {string} label
 *
 * @return {array} Array of schedules with shift information
 */
export const generateSchedule = (isMonthly, employeeShifts, employeeShiftOffers, availableOffers, submittedRequests, employeeMyShiftSwapOffers,
    availableShiftToSwapOffers, paycodes, mySwapProposals, openShifts, myOpenShiftRequests, availableVTO, myVTORequests, statusDictionary, personName, managerSettings, dateRanges, postedRequestDisplay = PostedRequestDisplay.requestName) => {
    let schedule = [];
    // TODO: Substitute labelDictionary with respect EN/FR translations
    // First push my shifts
    const sortedEmployeeShifts = _.sortBy(employeeShifts, ['startDateTime', 'endDateTime'])
    schedule.push(...sortedEmployeeShifts.map(
        // Beware of wrapping return with {} causes undefined since this. becomes new scope
        shift => buildUISchedule(shift.id, shift, '0', statusDictionary, shift, isMonthly, RequestSource.Offerer, false)
    ))

    // Paycodes
    schedule.push(..._.sortBy(paycodes, ['startDateTime', 'endDateTime']).map(
        // Beware of wrapping return with {} causes undefined since this. becomes new scope
        paycode => buildUISchedule(paycode.id, paycode, '1', {}, paycode, isMonthly, RequestSource.Offerer, false)
    ))

    // My OFFERS (LIGHTBLUE)
    for (const shiftOffer of employeeShiftOffers.filter(offer => moment.utc(offer.shift.startDateTime).isBetween(moment.utc(dateRanges.startDate), moment.utc(dateRanges.endDate), 'd', '[]'))) {
        let isPrivateOffer = !Aux.isNullOrUndefined(shiftOffer.idOfPrivateEmployees) && shiftOffer.privateOffer;
        schedule.push(
            buildUISchedule(shiftOffer.offerId,
                shiftOffer.shift,
                (shiftOffer.managerSettingId + 1000000000).toString(),
                statusDictionary,
                {
                    ...shiftOffer,
                    type: RequestTypes.toCover,
                },
                isMonthly,
                RequestSource.Offerer,
                isPrivateOffer,
                false,
                false,
                true,
                managerSettings,
            )
        )
    }

    // Available Offers
    for (const offer of availableOffers) {
        schedule.push(
            buildUISchedule(
                offer.offerId,
                offer.shift,
                (offer.managerSettingId + 2000000000).toString(),
                statusDictionary,
                {
                    ...offer,
                    type: RequestTypes.toCover,
                    startDateForDisplay: (offer.isPartial && offer.partialShift)
                                        ? offer.partialShift.startDateTime
                                        : offer.shift.startDateTime,
                },
                isMonthly,
                RequestSource.Requester,
                false,
                true,
                false,
                true,
                managerSettings,
                null,
                postedRequestDisplay,
            )
        )
    }

    // My submitted requests
    for (const request of submittedRequests) {
        schedule.push(
            buildUISchedule(
                request.offerId,
                request.shift,
                (request.managerSettingId + 1000000000).toString(),
                statusDictionary,
                {
                    ...request,
                    type: RequestTypes.toCover,
                    startDateForDisplay: (request.isPartial && request.partialShift)
                                        ? request.partialShift.startDateTime
                                        : request.shift.startDateTime,
                },
                isMonthly,
                RequestSource.Requester,
                false,
                false,
                false,
                true,
                managerSettings,
            ) // Requester Submitted
        )
    }

    for (const availableShiftToSwapOffer of availableShiftToSwapOffers) {
        let isPrivateOffer = !Aux.isNullOrUndefined(availableShiftToSwapOffer.idOfPrivateEmployees);
        let daysWithShift = []; //Keep track of grouped shifts on the same day
        let offset = availableShiftToSwapOffer.isSkipValidation ? 3000000000 : 2000000000;
        for (const shift of availableShiftToSwapOffer.shifts) {
            if (daysWithShift.find(x => moment.utc(x).startOf('day').isSame(moment.utc(shift.startDateTime).startOf('day')))) {
                continue;
            }
            schedule.push(
                buildUISchedule(
                    availableShiftToSwapOffer.offerId,
                    shift,
                    (availableShiftToSwapOffer.managerSettingId + offset).toString(),
                    statusDictionary,
                    {
                        ...availableShiftToSwapOffer,
                        type: RequestTypes.shiftSwap,
                        startDateForDisplay: (availableShiftToSwapOffer.isPartial && availableShiftToSwapOffer.partialShift)
                                        ? availableShiftToSwapOffer.partialShift.startDateTime
                                        : availableShiftToSwapOffer.shifts[0].startDateTime,

                    },
                    isMonthly,
                    RequestSource.Requester,
                    isPrivateOffer,
                    true,
                    false,
                    true,
                    managerSettings,
                    null,
                    postedRequestDisplay,
                    availableShiftToSwapOffer.isSkipValidation,
                )
            );
            daysWithShift.push(shift.startDateTime);
        }
    }
    for (const myShiftSwapOffer of employeeMyShiftSwapOffers) {
        for (const shift of myShiftSwapOffer.shifts) {
            if (moment.utc(shift.startDateTime).isBetween(moment.utc(dateRanges.startDate), moment.utc(dateRanges.endDate), 'd', '[]')) {
                schedule.push(
                    buildUISchedule(
                        myShiftSwapOffer.offerId,
                        shift,
                        (myShiftSwapOffer.managerSettingId + 1000000000).toString(),
                        statusDictionary,
                        {
                            ...myShiftSwapOffer,
                            type: RequestTypes.shiftSwap,
                        },
                        isMonthly,
                        RequestSource.Offerer,
                        false,
                        false,
                        false,
                        true,
                        managerSettings,
                    )
                )
            }
        }
    }
    const mySwapProposalsMadeByMe = mySwapProposals.filter(x => !(x.isProposedByOfferer && [RequestStatus.Offered, RequestStatus.Declined].includes(x.status)));
    for (const mySwapProposal of mySwapProposalsMadeByMe) {
        let proposal = mySwapProposal.proposals[mySwapProposal.proposals.length - 1];
        if (proposal) {
            for (const shift of proposal.shifts) {//TODO : do we want many submitted/retr lines if many shifts in proposal
                schedule.push(
                    buildUISchedule(mySwapProposal.offerId,
                        shift,
                        (mySwapProposal.managerSettingId + 1000000000).toString(),
                        statusDictionary,
                        {
                            ...mySwapProposal,
                            proposals: [proposal],
                            type: RequestTypes.shiftSwap,
                        },
                        isMonthly,
                        RequestSource.Requester,
                        false,
                        false,
                        true,
                        true,
                        managerSettings,
                    )
                )
            }
        }
    }

    for (const openShift of openShifts) {
        const shift = openShift.shifts[0]
        for (const managerSettingId of openShift.managerSettingIds) {
            schedule.push(
                buildUISchedule(
                    openShift.key,
                    shift,
                    (parseInt(managerSettingId) + 2000000000).toString(),
                    statusDictionary,
                    {
                        ...openShift,
                        type: RequestTypes.openShift,
                        source: RequestSource.Requester, // Incoming
                        managerSettingId: managerSettingId,
                        status: RequestStatus.Offered,
                    },
                    isMonthly,
                    RequestSource.Requester,
                    false,
                    true,
                    false,
                    false,
                    managerSettings,
                    managerSettingId,
                    postedRequestDisplay,
                )
            )
        }
    }

    for (const request of myOpenShiftRequests) {
        schedule.push(
            buildUISchedule(
                request.id,
                request.shift,
                (parseInt(request.managerSettingId) + 1000000000).toString(),
                statusDictionary,
                {
                    ...request,
                    type: RequestTypes.openShift,
                },
                isMonthly,
                RequestSource.Offerer,
                false,
                false,
                false,
                true,
                managerSettings,
            )
        )
    }

    // Voluntary time off
    for (const vto of availableVTO) {
        let employeeShift
        if (vto.affectedShifts.length) {
            let minMax = vto.affectedShifts.map(x => { return { startDateTime: x.startDateTime, endDateTime: x.endDateTime } });
            let startDate = minMax[0].startDateTime;
            let endDate = minMax[0].endDateTime;

            for (let dates in minMax) {
                if (minMax[dates].startDateTime < startDate) {
                    startDate = minMax[dates].startDateTime;
                }
                if (minMax[dates].endDateTime > endDate) {
                    endDate = minMax[dates].endDateTime;
                }
            }

            // Create a deep copy to avoid mutating the original shift object
            employeeShift = JSON.parse(JSON.stringify(vto.affectedShifts[0]));
            employeeShift.startDateTime = startDate;
            employeeShift.endDateTime = endDate;

        } else {
            employeeShift = {
                startDateTime: vto.timeOffStartDate,
                endDateTime: vto.timeOffEndDate
            };
        }


        schedule.push(buildUISchedule(
            vto.offerId,
            employeeShift,
            (parseInt(vto.managerSettingId) + 2000000000).toString(),
            statusDictionary,
            {
                ...vto,
                type: RequestTypes.voluntaryTimeOff,
                source: RequestSource.Requester,
            },
            isMonthly,
            RequestSource.Requester,
            false,
            true,
            false,
            false,
            managerSettings,
            vto.managerSettingId,
            postedRequestDisplay,
        ));
    }

    for (const vto of myVTORequests) {
        let employeeShift
        if (vto.approvedShifts.length > 0) {
            const shift = vto.approvedShifts.find(shift => moment.utc(shift.shiftInfo.startDateLocationTime).isSameOrAfter(moment.utc(vto.timeOffStartDate), 'd')
                && moment.utc(shift.shiftInfo.startDateLocationTime).isBetween(moment.utc(dateRanges.startDate), moment.utc(dateRanges.endDate), 'd', '[]')
            )
            employeeShift = shift ? shift.shiftInfo.shiftDetails : undefined
        }
        else {

            if (vto.affectedShifts.length) {

                let minMax = vto.affectedShifts.map(x => { return { startDateTime: x.startDateTime, endDateTime: x.endDateTime } });
                let startDate = minMax[0].startDateTime;
                let endDate = minMax[0].endDateTime;

                for (let dates in minMax) {
                    if (minMax[dates].startDateTime < startDate) {
                        startDate = minMax[dates].startDateTime;
                    }
                    if (minMax[dates].endDateTime > endDate) {
                        endDate = minMax[dates].endDateTime;
                    }
                }

                // Create a deep copy to avoid mutating the original shift object
                employeeShift = JSON.parse(JSON.stringify(vto.affectedShifts[0]));
                employeeShift.startDateTime = startDate;
                employeeShift.endDateTime = endDate;
            } else {
                employeeShift = {
                    startDateTime: vto.timeOffStartDate,
                    endDateTime: vto.timeOffEndDate
                };
            }


        }

        if (employeeShift) {
            schedule.push(buildUISchedule(
                vto.offerId,
                employeeShift,
                (parseInt(vto.managerSettingId) + 1000000000).toString(),
                statusDictionary,
                {
                    ...vto,
                    type: RequestTypes.voluntaryTimeOff,
                    source: RequestSource.Offerer,
                },
                isMonthly,
                RequestSource.Offerer,
                false,
                false,
                false,
                true,
                managerSettings,
                vto.managerSettingId
            ))
        }
    }

    return schedule;
}

export const generateBillboardActions = (managerSettings) => managerSettings.map((managerSetting) => ({
    label: managerSetting.name,
    value: managerSetting.id,
    disabled: false,
    guid: managerSetting.aggregateRootId,
    probationEndDate: managerSetting.probationEndDate,
    isBackToBackEnabled: managerSetting.isBackToBackEnabled,
    isAllowMultipleRequests: managerSetting.isAllowMultipleRequests,
    type: managerSetting.type,
    workRuleExcludedIds: managerSetting.workRuleExcludedIds,
    isPartialShiftEnabled: managerSetting.isPartialShiftEnabled,
    segmentTagExcludedIds: managerSetting.segmentTagExcludedIds,
}));

export const standardizeNotificationList = (myEmployeeId, list, statusDictionary) => {
    let newNotifList = []
    const actionLabel = (status) => status === RequestStatus.Pending ? 'set to ' : ''
    const actionEmployee = (status, managerName, employeeFromName) =>
        [RequestStatus.Approved, RequestStatus.Refused, RequestStatus.Pending].includes(status)
            ? managerName
            : employeeFromName;


    for (let offer of list) {
        if (offer.requestType === RequestTypes.voluntaryTimeOff) {
            newNotifList.push({
                isNew: offer.isNew,
                isOwnOffer: false,
                employeeName: offer.employeeFromName,
                status: offer.status,
                statusDisplay: statusDictionary[offer.status].value,
                requestType: offer.requestType,
                offerId: offer.offerId,
                notificationDate: formatDateRange(offer.submissionStartDate, offer.submissionEndDate, getAsLongDate),
                managerSettingId: offer.managerSettingId,
                shiftsDates: formatDateRange(offer.timeOffStartDate, offer.timeOffEndDate, getAsLongDate),
                isValid: offer.isValid,
            })
        } else if (offer.requestType === RequestTypes.shiftSwap) {
            let shiftsDates = "";
            if (offer.shifts.length > 1) {
                shiftsDates = offer.shifts.length + " shifts offered";
            } else {
                let shift;
                if (offer.isPartial) {
                    shift = offer.partialShift;
                } else {
                    shift = offer.shifts[0];
                }

                shiftsDates = `${shift.label ?? ""} ${formatAs(shift.startDateTime, DateFnsFormats.VERBOSE_LONG_DATETIME_FORMAT)} - ${getTimeOnly(shift.endDateTime)}`;
            }

            let isOwnOffer = myEmployeeId === offer.employeeFromId;
            let nbNew = offer.isNew;
            let employeeName = "";
            let status = offer.status;
            if (isOwnOffer) {// I am EE1
                nbNew = offer.proposals.filter(proposal => proposal.isNew).length;
                if (!nbNew) {
                    nbNew = offer.isNew;
                }
            } else { // I am EE2
                employeeName = actionEmployee(offer.status, offer.managerName, offer.employeeFromName)
                if (offer.status === RequestStatus.Submitted && offer.proposals.length === 0) {//(private) someone else already submitted
                    //Show submitted until someone complains JP 2021-03-31
                }
                else if (offer.status === RequestStatus.Submitted
                    && offer.proposals.length
                    && !offer.proposals.some(proposal => proposal.status === RequestStatus.Submitted)) {//Verify it is my proposal that is accepted and not someone else
                    status = offer.proposals[0].status
                }
            }

            newNotifList.push({
                isNew: nbNew,
                isOwnOffer: isOwnOffer,
                employeeName: employeeName,
                status: status,
                statusDisplay: actionLabel(status) + statusDictionary[status].value,
                requestType: offer.requestType,
                offerId: offer.offerId,
                notificationDate: offer.offerDate,
                managerSettingId: offer.managerSettingId,
                shiftsDates: shiftsDates,
                isValid: offer.isValid,
            })
        } else if (offer.requestType === RequestTypes.toCover) {
            let shift;
            if (offer.isPartial) {
                shift = offer.partialShift;
            } else {
                shift = offer.shifts[0];
            }
            const shiftsDates = `${shift.label ?? ""} ${formatAs(shift.startDateTime, DateFnsFormats.VERBOSE_LONG_DATETIME_FORMAT)} - ${getTimeOnly(shift.endDateTime)}`;
            let employeeName = "";
            const isOwnOffer = myEmployeeId === offer.employeeFromId;
            if (!isOwnOffer) {
                employeeName = actionEmployee(offer.status, offer.managerName, offer.employeeFromName)
            }
            newNotifList.push({
                isNew: offer.isNew,
                isOwnOffer: isOwnOffer,
                employeeName: employeeName,
                status: offer.status,
                statusDisplay: actionLabel(offer.status) + statusDictionary[offer.status].value,
                requestType: offer.requestType,
                offerId: offer.offerId,
                notificationDate: offer.offerDate,
                managerSettingId: offer.managerSettingId,
                shiftsDates: shiftsDates,
                isValid: offer.isValid,
            })
        }
    }

    return newNotifList;
}

// TODO 2022-11-10 kathy - move to its own functional component
const generateSidePanelHistory = (history = [], managerSettingNames, classes) => {
    if (!history.length) {
        return <></>;
    }

    return (
        <>
            <Divider style={{ margin: '10px 0', width: '100%' }} />
            <Grid item xs={12}>
                <Grid style={{ marginBottom: '10px' }} item xs={12}><Typography component='h1' className={classes.shiftInfoHeader}>History</Typography></Grid>
                <HistoryPanel managerSettingNames={managerSettingNames} handleClick={noop} historyResponse={history} />
            </Grid>
        </>
    );
}

// TODO 2022-11-10 kathy - move to its own functional component
function generateSidePanelPreferedDates(data) {
    const { classes } = this.props;

    if (data.raw && data.raw.datePreferences && data.raw.datePreferences.length) {
        return (
            <React.Fragment>
                <Divider style={{ margin: '10px 0', width: '100%' }} />
                <Grid style={{ marginBottom: '10px' }} item xs={12} className={classes.boxShadow}>
                    <Grid style={{ marginBottom: '10px' }} item xs={12}><Typography component='h1' className={classes.shiftInfoHeader}>Preferred dates</Typography></Grid>
                    <List>
                        {data.raw.datePreferences.map(d => <Typography style={{ padding: '0px 16px' }} className={classes.recipientNames}>{formatAs(removeBrowserTimezoneConversion(d), DateFnsFormats.VERBOSE_LONG_DATE_FORMAT)}</Typography>)}
                    </List>
                </Grid>
            </React.Fragment>
        );
    }
}

// TODO 2022-11-10 kathy - move to its own functional component
function generateSidePanelRecipients(data) {
    const { classes } = this.props

    if (data.source !== RequestSource.Offerer
        || ![RequestTypes.toCover, RequestTypes.shiftSwap].includes(data.type)
        || !data.raw.employeesToList) { //only for ee1's private TC,SS offers
        return
    }

    let employeesToList = data.raw.employeesToList.length ? data.raw.employeesToList : [{ name: 'Sent to billboard' }]
    return (
        <Grid item xs={12} className={classes.boxShadow}>
            <CollapsableCard classes={{ title: classes.h1 }} title={'Recipients'} expanded={this.state.isOpenRecipientEmployees} handleCollapse={() => this.toggleIsOpenRecipientEmployees()}>
                {employeesToList && employeesToList.length > 0 ?
                    employeesToList.map(ee => <Typography className={classes.recipientNames}>{ee.name}</Typography>)
                    : null
                }
            </CollapsableCard>
        </Grid>
    )
}

export const statusIcon = (status, color, hasProposals = false) => {
    let icon;
    switch (status) {
        case RequestStatus.Offered:
            if (hasProposals) {
                icon = <span style={{ color: color }}><FontAwesomeIcon icon={faArrowAltFromRight} /></span>
            } else {
                icon = <span style={{ color: color }}><FontAwesomeIcon icon={faArrowAltFromLeft} /></span>
            }
            break;
        case RequestStatus.Submitted:
        case RequestStatus.Pending:
            icon = <span style={{ color: color }}><FontAwesomeIcon icon={faShareSquare} /></span>
            break;
        case RequestStatus.Approved:
            icon = <span style={{ color: color }}><FontAwesomeIcon icon={faCheckSquare} /></span>
            break;
        case RequestStatus.Refused:
            icon = <span style={{ color: color }}><FontAwesomeIcon icon={faTimesCircle} /></span>
            break;
        case RequestStatus.OfferRetracted:
        case RequestStatus.RequestRetracted:
            icon = <span style={{ color: color }}><FontAwesomeIcon icon={faHistory} /></span>
            break;
        case RequestStatus.Expired:
            icon = <span style={{ color: color }}><FontAwesomeIcon icon={faAlarmExclamation} /></span>
            break;
        default:
            icon = '';
    }
    return icon;
}
